import { CellStyle, ColDef, ValueFormatterParams } from "ag-grid-community";
import { CampaignEventData } from "../../models/CampaignEventData";

export const useTableData = () => {
	const columnDefs: ColDef<CampaignEventData>[] = [
		{
			field: "HeatNumber",
			headerName: "Heat Number",
			flex: 1.5,
			colSpan: (params) => {
				if (params.data?.HeatNumber?.startsWith("Roll change")) {
					return 2;
				}
				return 1;
			},
			cellStyle: (params) => {
				if (params.data?.IsTotal === 1) {
					return { fontWeight: "bold" } as CellStyle;
				}

				if (params.data?.HeatNumber?.startsWith("Roll change")) {
					return { fontStyle: "italic", color: "#666" } as CellStyle;
				}

				return null;
			},
		},
		{
			field: "Grade",
			headerName: "Grade",
			flex: 1,
		},
		{
			field: "BilletLength",
			headerName: "Billet Length",
			flex: 1,
		},
		{
			field: "HotbedLength",
			headerName: "Hotbed Length",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 1,
							maximumFractionDigits: 1,
						}).format(params.value)
					: "",
		},
		{
			field: "ShearLength",
			headerName: "Shear Length",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 1,
							maximumFractionDigits: 1,
						}).format(params.value)
					: "",
		},
		{
			field: "BilletsCharged",
			headerName: "Billets Charged",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "BilletsRolled",
			headerName: "Billets Rolled",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "TonsCharged",
			headerName: "Tons Charged",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "TonsRolled",
			headerName: "Tons Rolled",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "TonsFinished",
			headerName: "Tons Finished",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "BilletsRejected",
			headerName: "Billets Rejected",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "Cobbles",
			headerName: "Cobbles",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "MillYield",
			headerName: "Mill Yield",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? `${Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)}%`
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
		{
			field: "FinishedYield",
			headerName: "Finished Yield",
			flex: 1,
			valueFormatter: (params: ValueFormatterParams<CampaignEventData>) =>
				params.value != null
					? `${Intl.NumberFormat("en-US", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						}).format(params.value)}%`
					: "",
			cellStyle: (params) =>
				params.data?.IsTotal === 1 ? { fontWeight: "bold" } : undefined,
		},
	];

	return { columnDefs };
};
